const es = {
    'ui.menus.user.home': 'Inicio',
    'ui.menus.user.company': 'Empresa',
    'ui.menus.user.documents': 'Documentos',
    'ui.menus.user.portal': 'Portal',
    'ui.menus.user.users': 'Usuarios',
    'ui.menus.user.admin': 'Administración',
    'ui.menus.user.proposalProject': 'Propuesta de proyecto',
    'ui.menus.user.improvementChannel': 'Canal de mejora',
    'ui.menus.user.serviceDelegation': 'Delegaciones de Servicio',
    'ui.menus.user.improvementProposal': 'Propuesta de mejora',
    'ui.menus.user.logout': 'Cerrar sesión',
    'ui.menus.user.hello': 'Hola',
    'ui.menus.user.signing': 'Fichaje',
    'ui.menus.user.applications': 'Aplicaciones',
    'ui.menus.user.serviceCompany': 'ServiceCompany',
    'ui.menus.user.delegationService' : 'Servicios de las Delegaciones',
    'ui.menus.user.contactDelegationService' : 'Contacto Servicios',
    'ui.menus.user.contractDelegationService' : 'Contratos Servicios',
    'ui.menus.user.unionDelegationService' : 'Gremios',



    'ui.menus.admin.home': 'Inicio',
    'ui.menus.admin.users': 'Gest. Usuarios',
    'ui.menus.admin.permissionGroups': 'Gest. Grupos Permisos',
    'ui.menus.admin.jobPositions': 'Puestos de Trabajo (Permisos)',
    'ui.menus.admin.permissions': 'Gest. Permisos',
    'ui.menus.admin.scheduledCommands': 'Gest. Comandos Programados',
    'ui.menus.admin.user': 'Vista Usuario',
    'ui.menus.admin.logout': 'Cerrar sesión',
    'ui.menus.admin.proposalProject': 'Propuesta de proyecto',
    'ui.menus.admin.delegationService' : 'Servicios de las Delegaciones',
    'ui.menus.admin.contactDelegationService' : 'Contacto Servicios',
    'ui.menus.admin.contractDelegationService' : 'Contratos Servicios',
    'ui.menus.admin.unionDelegationService' : 'Gremios',
    'ui.menus.user.csAlertConfiguration': 'Configuración de alertas CS',

    'ui.application.aszende_app': 'Intranet Aszende app',
    'ui.application.corporate_webmail': 'Correo web corporativo',
    'ui.application.learning_aszende': 'Aprendizaje Aszende',
    'ui.application.binsa': 'Binsa',
    'ui.application.crm': 'CRM',
    'ui.application.it_portal': 'Portal IT',
    'ui.application.agile': 'Agile',
    'ui.application.power_bi': 'Power Bi',
    'ui.application.anydesk': 'Anydesk',
    'ui.application.jori': 'Jori - Retribución flexible',
    'ui.application.web_fleet_solutions': 'Soluciones de flota web',
    'ui.application.aszende_fleet': 'Flotas Aszende',
    'ui.application.salesforce': 'Salesforce',
    'ui.application.hydra': 'Hydra - Dialoga',
    'ui.menus.admin.serviceCompany': 'Empresa de Servicio',
    'ui.menus.user.extra': 'Extra',
    'ui.menus.user.installationExtra': 'Instalación Extra'
};

export default es;